/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ExternalPartners {
    None = 'None',
    Clio = 'Clio',
    MyCase = 'MyCase',
    Smokeball = 'Smokeball'
}

export function ExternalPartnersFromJSON(json: any): ExternalPartners {
    return ExternalPartnersFromJSONTyped(json, false);
}

export function ExternalPartnersFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalPartners {
    return json as ExternalPartners;
}

export function ExternalPartnersToJSON(value?: ExternalPartners | null): any {
    return value as any;
}

